export default {
  GET_PATIENT_DETAILS_REQUEST: "GET_PATIENT_DETAILS_REQUEST",
  GET_PATIENT_DETAILS_SUCCESS: "GET_PATIENT_DETAILS_SUCCESS",
  GET_PATIENT_DETAILS_FAILURE: "GET_PATIENT_DETAILS_FAILURE",

  GET_PATIENT_VITALS_REQUEST: "GET_PATIENT_VITALS_REQUEST",
  GET_PATIENT_VITALS_SUCCESS: "GET_PATIENT_VITALS_SUCCESS",
  GET_PATIENT_VITALS_FAILURE: "GET_PATIENT_VITALS_FAILURE",

  GET_PATIENT_CONSULTATION_REQUEST: "GET_PATIENT_CONSULTATION_REQUEST",
  GET_PATIENT_CONSULTATION_SUCCESS: "GET_PATIENT_CONSULTATION_SUCCESS",
  GET_PATIENT_CONSULTATION_FAILURE: "GET_PATIENT_CONSULTATION_FAILURE",

  GET_PATIENT_VITALS_RANGE_REQUEST: "GET_PATIENT_VITALS_RANGE_REQUEST",
  GET_PATIENT_VITALS_RANGE_SUCCESS: "GET_PATIENT_VITALS_RANGE_SUCCESS",
  GET_PATIENT_VITALS_RANGE_FAILURE: "GET_PATIENT_VITALS_RANGE_FAILURE",

  GET_PATIENT_LEAP_SCORE_REQUEST: "GET_PATIENT_LEAP_SCORE_REQUEST",
  GET_PATIENT_LEAP_SCORE_SUCCESS: "GET_PATIENT_LEAP_SCORE_SUCCESS",
  GET_PATIENT_LEAP_SCORE_FAILURE: "GET_PATIENT_LEAP_SCORE_FAILURE",

  GET_PATIENT_HISTORY_REQUEST: "GET_PATIENT_HISTORY_REQUEST",
  GET_PATIENT_HISTORY_SUCCESS: "GET_PATIENT_HISTORY_SUCCESS",
  GET_PATIENT_HISTORY_FAILURE: "GET_PATIENT_HISTORY_FAILURE",

  CREATE_PATIENT_HISTORY_REQUEST: "CREATE_PATIENT_HISTORY_REQUEST",
  CREATE_PATIENT_HISTORY_SUCCESS: "CREATE_PATIENT_HISTORY_SUCCESS",
  CREATE_PATIENT_HISTORY_FAILURE: "CREATE_PATIENT_HISTORY_FAILURE",

  UPDATE_PATIENT_HISTORY_REQUEST: "UPDATE_PATIENT_HISTORY_REQUEST",
  UPDATE_PATIENT_HISTORY_SUCCESS: "UPDATE_PATIENT_HISTORY_SUCCESS",
  UPDATE_PATIENT_HISTORY_FAILURE: "UPDATE_PATIENT_HISTORY_FAILURE",

  CREATE_VITALS_REQUEST: "CREATE_VITALS_REQUEST",
  CREATE_VITALS_SUCCESS: "CREATE_VITALS_SUCCESS",
  CREATE_VITALS_FAILURE: "CREATE_VITALS_FAILURE",

  RESET_VITALS_CREATION_STATE: "RESET_VITALS_CREATION_STATE",

  GET_PATIENT_TESTS_REQUEST: "GET_PATIENT_TESTS_REQUEST",
  GET_PATIENT_TESTS_SUCCESS: "GET_PATIENT_TESTS_SUCCESS",
  GET_PATIENT_TESTS_FAILURE: "GET_PATIENT_TESTS_FAILURE",

  RESET_TEST_CREATION_STATE: "RESET_TEST_CREATION_STATE",

  SUBMIT_PATIENT_TESTS_REQUEST: "SUBMIT_PATIENT_TESTS_REQUEST",
  SUBMIT_PATIENT_TESTS_SUCCESS: "SUBMIT_PATIENT_TESTS_SUCCESS",
  SUBMIT_PATIENT_TESTS_FAILURE: "SUBMIT_PATIENT_TESTS_FAILURE",

  GET_LIFESTYLE_CHARTS_REQUEST: "GET_LIFESTYLE_CHARTS_REQUEST",
  GET_LIFESTYLE_CHARTS_SUCCESS: "GET_LIFESTYLE_CHARTS_SUCCESS",
  GET_LIFESTYLE_CHARTS_FAILURE: "GET_LIFESTYLE_CHARTS_FAILURE",

  GET_RECOMMENDED_DIET_PLAN_REQUEST: "GET_RECOMMENDED_DIET_PLAN_REQUEST",
  GET_RECOMMENDED_DIET_PLAN_SUCCESS: "GET_RECOMMENDED_DIET_PLAN_SUCCESS",
  GET_RECOMMENDED_DIET_PLAN_FAILURE: "GET_RECOMMENDED_DIET_PLAN_FAILURE",

  GET_RECOMMENDED_LIFESTYLE_REQUEST: "GET_RECOMMENDED_LIFESTYLE_REQUEST",
  GET_RECOMMENDED_LIFESTYLE_SUCCESS: "GET_RECOMMENDED_LIFESTYLE_SUCCESS",
  GET_RECOMMENDED_LIFESTYLE_FAILURE: "GET_RECOMMENDED_LIFESTYLE_FAILURE",

  CREATE_OR_UPDATE_RECOMMENDED_LIFESTYLE_REQUEST: "CREATE_OR_UPDATE_RECOMMENDED_LIFESTYLE_REQUEST",
  CREATE_OR_UPDATE_RECOMMENDED_LIFESTYLE_SUCCESS: "CREATE_OR_UPDATE_RECOMMENDED_LIFESTYLE_SUCCESS",
  CREATE_OR_UPDATE_RECOMMENDED_LIFESTYLE_FAILURE: "CREATE_OR_UPDATE_RECOMMENDED_LIFESTYLE_FAILURE",

  GET_EMOTION_CHARTS_REQUEST: "GET_EMOTION_CHARTS_REQUEST",
  GET_EMOTION_CHARTS_SUCCESS: "GET_EMOTION_CHARTS_SUCCESS",
  GET_EMOTION_CHARTS_FAILURE: "GET_EMOTION_CHARTS_FAILURE",

  GET_PHYSICAL_FITNESS_REQUEST: "GET_PHYSICAL_FITNESS_REQUEST",
  GET_PHYSICAL_FITNESS_SUCCESS: "GET_PHYSICAL_FITNESS_SUCCESS",
  GET_PHYSICAL_FITNESS_FAILURE: "GET_PHYSICAL_FITNESS_FAILURE",

  GET_VISITS_CHARTS_REQUEST: "GET_VISITS_CHARTS_REQUEST",
  GET_VISITS_CHARTS_SUCCESS: "GET_VISITS_CHARTS_SUCCESS",
  GET_VISITS_CHARTS_FAILURE: "GET_VISITS_CHARTS_FAILURE",

  GET_WEIGHT_GAIN_CHART_REQUEST: "GET_WEIGHT_GAIN_CHART_REQUEST",
  GET_WEIGHT_GAIN_CHART_SUCCESS: "GET_WEIGHT_GAIN_CHART_SUCCESS",
  GET_WEIGHT_GAIN_CHART_FAILURE: "GET_WEIGHT_GAIN_CHART_FAILURE",

  GET_PATIENT_COMPLAINTS_REQUEST: "GET_PATIENT_COMPLAINTS_REQUEST",
  GET_PATIENT_ENDED_COMPLAINTS_REQUEST: "GET_PATIENT_ENDED_COMPLAINTS_REQUEST",
  GET_PATIENT_COMPLAINTS_SUCCESS: "GET_PATIENT_COMPLAINTS_SUCCESS",
  GET_PATIENT_COMPLAINTS_FAILURE: "GET_PATIENT_COMPLAINTS_FAILURE",

  GET_PATIENT_RISKS_REQUEST: "GET_PATIENT_RISKS_REQUEST",
  GET_PATIENT_ASSESS_RISKS_REQUEST: "GET_PATIENT_ASSESS_RISKS_REQUEST",
  GET_PATIENT_ENDED_RISKS_REQUEST: "GET_PATIENT_ENDED_RISKS_REQUEST",
  GET_PATIENT_RISKS_SUCCESS: "GET_PATIENT_RISKS_SUCCESS",
  GET_PATIENT_RISKS_FAILURE: "GET_PATIENT_RISKS_FAILURE",

  CREATE_COMPLAINT_REQUEST: "CREATE_COMPLAINT_REQUEST",
  CREATE_COMPLAINT_SUCCESS: "CREATE_COMPLAINT_SUCCESS",
  CREATE_COMPLAINT_FAILURE: "CREATE_COMPLAINT_FAILURE",

  CREATE_RISK_REQUEST: "CREATE_RISK_REQUEST",
  CREATE_RISK_SUCCESS: "CREATE_RISK_SUCCESS",
  CREATE_RISK_FAILURE: "CREATE_RISK_FAILURE",

  UPDATE_COMPLAINT_REQUEST: "UPDATE_COMPLAINT_REQUEST",
  UPDATE_COMPLAINT_SUCCESS: "UPDATE_COMPLAINT_SUCCESS",
  UPDATE_COMPLAINT_FAILURE: "UPDATE_COMPLAINT_FAILURE",

  UPDATE_RISK_REQUEST: "UPDATE_RISK_REQUEST",
  UPDATE_RISK_SUCCESS: "UPDATE_RISK_SUCCESS",
  UPDATE_RISK_FAILURE: "UPDATE_RISK_FAILURE",

  UPDATE_PATIENT_DETAILS_REQUEST: "UPDATE_PATIENT_DETAILS_REQUEST",
  UPDATE_PATIENT_DETAILS_SUCCESS: "UPDATE_PATIENT_DETAILS_SUCCESS",
  UPDATE_PATIENT_DETAILS_FAILURE: "UPDATE_PATIENT_DETAILS_FAILURE",

  ADD_WEIGHT_GAIN_CHART_DATA_REQUEST: "ADD_WEIGHT_GAIN_CHART_DATA_REQUEST",
  ADD_WEIGHT_GAIN_CHART_DATA_SUCCESS: "ADD_WEIGHT_GAIN_CHART_DATA_SUCCESS",
  ADD_WEIGHT_GAIN_CHART_DATA_FAILURE: "ADD_WEIGHT_GAIN_CHART_DATA_FAILURE",

  GET_PRESCRIPTION_CHART_REQUEST: "GET_PRESCRIPTION_CHART_REQUEST",
  GET_PRESCRIPTION_CHART_SUCCESS: "GET_PRESCRIPTION_CHART_SUCCESS",
  GET_PRESCRIPTION_CHART_FAILURE: "GET_PRESCRIPTION_CHART_FAILURE",

  GET_DFMR_CHART_REQUEST: "GET_DFMR_CHART_REQUEST",
  GET_DFMR_CHART_SUCCESS: "GET_DFMR_CHART_SUCCESS",
  GET_DFMR_CHART_FAILURE: "GET_DFMR_CHART_FAILURE",

  GET_EMOTION_DATA_REQUEST: "GET_EMOTION_DATA_REQUEST",
  GET_EMOTION_DATA_SUCCESS: "GET_EMOTION_DATA_SUCCESS",
  GET_EMOTION_DATA_FAILURE: "GET_EMOTION_DATA_FAILURE",

  CREATE_CONDITION_REQUEST: "CREATE_CONDITION_REQUEST",
  CREATE_CONDITION_SUCCESS: "CREATE_CONDITION_SUCCESS",
  CREATE_CONDITION_FAILURE: "CREATE_CONDITION_FAILURE",

  GET_CONDITION_REQUEST: "GET_CONDITION_REQUEST",
  GET_CONDITION_SUCCESS: "GET_CONDITION_SUCCESS",
  GET_CONDITION_FAILURE: "GET_CONDITION_FAILURE",

  RESET_CONDITION_CREATION_STATE: "RESET_CONDITION_CREATION_STATE",

  GET_CONDITION_TIMELINE_REQUEST: "GET_CONDITION_TIMELINE_REQUEST",
  GET_CONDITION_TIMELINE_SUCCESS: "GET_CONDITION_TIMELINE_SUCCESS",
  GET_CONDITION_TIMELINE_FAILURE: "GET_CONDITION_TIMELINE_FAILURE",
  
};
